export const environment = {
	production: false,
	useProxy: false,
	buildType: 'die',
	style: 'violet',
	// Dedicated ip-be-regstar-front App Registration (tenant 3f998017-0d99-4e9a-ae46-fb070d03b2cc,
	// provided by operator 2026-09-25). Operator registers this redirectUri manually in Azure Portal.
	msalConfig: {
		auth: {
			clientId: 'b66a99e8-7077-4a1e-be76-ea6312769536',
			authority: 'https://login.microsoftonline.com/3f998017-0d99-4e9a-ae46-fb070d03b2cc',
			redirectUri: 'https://frontend.beregstardie.alzp.tgscloud.net/auth-callback'
		}
	},
	// Confirmed 2026-10-02: real scope name is Regstar.Admin.all (corrected from Employees.Admin.All).
	apiConfig: {
		scopes: ['api://b66a99e8-7077-4a1e-be76-ea6312769536/Regstar.Admin.all']
	}
};
